import './articleDetailPage.less'

const loadInteractivePDF = () => {

    if (!document.querySelector(".openInteractivePDF")) {
        return;
    }
    document.querySelectorAll(".openInteractivePDF").forEach((item) => {
        item.addEventListener("click", (e) => {
            document.body.classList.add("modalOpen");
            document.querySelector("#InteractivePDFPanel").style.visibility = "visible";
            e.preventDefault();
        });
    });

    document.querySelector(".close").addEventListener("click", (e) => {
        document.body.classList.remove("modalOpen");
        document.querySelector("#InteractivePDFPanel").style.visibility = "";
    });

    window.setInterval(() => {
        var viewer = document.querySelector("#viewer");
        var canvas = document.querySelector(".canvasWrapper canvas");

        if (canvas && viewer) {
            var _ogDimensions = { w: 780, h: 540 };
            var _cDimensions = { w: parseFloat(document.documentElement.clientWidth) - 18, h: parseFloat(document.documentElement.clientHeight) - 18 };

            var _wScale = _cDimensions.w / _ogDimensions.w;
            var _hScale = _cDimensions.h / _ogDimensions.h;

            var finalScale = Math.min(_wScale, _hScale);

            // console.log("final Scale:: ", finalScale);

            viewer.setAttribute("style", `--scale-factor: ${finalScale};`);
            canvas.style.width = "100%";
            canvas.style.height = "100%";
        }
    }, 50)
}

let pctarr = [];

const articleSlugArr = window.location.href.replace("https://").split("/");
const articleSlug = articleSlugArr[articleSlugArr.length - 1];

const step = () => {
    document.querySelector(".progress-time").innerText = formatTime(Math.round(sound.duration() - sound.seek()));
    var prog = (sound.seek() / sound.duration()) * 100;
    document.querySelector(".current-progress").style.width = prog + "%";

    if (parseInt(prog) >= 25 && pctarr.length == 0) {
        dataLayer.push({
            'event': 'GAEvent',
            'eventAction': 'progress_25',
            'eventCategory': 'article_audio',
            'eventLabel': articleSlug,
        });
        pctarr.push(0);
    } else if (parseInt(prog) >= 50 && pctarr.length == 1) {
        dataLayer.push({
            'event': 'GAEvent',
            'eventAction': 'progress_50',
            'eventCategory': 'article_audio',
            'eventLabel': articleSlug,
        });
        pctarr.push(1);
    } else if (parseInt(prog) >= 75 && pctarr.length == 2) {
        dataLayer.push({
            'event': 'GAEvent',
            'eventAction': 'progress_75',
            'eventCategory': 'article_audio',
            'eventLabel': articleSlug,
        });
        pctarr.push(2);
    } else if (parseInt(prog) >= 100 && pctarr.length == 3) {
        dataLayer.push({
            'event': 'GAEvent',
            'eventAction': 'progress_100',
            'eventCategory': 'article_audio',
            'eventLabel': articleSlug,
        });
        pctarr.push(3);
    }
};
let progressTimer = null;
const loadAuthorNote = () => {
    const audioPlayer = document.querySelector("#audioPlayer");
    if (!audioPlayer || !window.Howl) {
        return;
    }


    window.sound = new Howl({
        src: [audioPlayer.dataset.audio],
        html5: true,
        onend: () => {
            dataLayer.push({
                'event': 'GAEvent',
                'eventAction': 'completed',
                'eventCategory': 'article_audio',
                'eventLabel': articleSlug,
            });
        }
    });
    const play = document.querySelector(".play");
    const pause = document.querySelector(".pause");
    const progress = document.querySelector(".progress-all");
    const mute = document.querySelector(".mute");
    const unmute = document.querySelector(".unmute");

    console.log("loading audio player");

    mute.addEventListener("click", (e) => {
        sound.mute(true);
        mute.style.display = "none";
        unmute.style.display = "block";


        dataLayer.push({
            'event': 'GAEvent',
            'eventAction': 'mute',
            'eventCategory': 'article_audio',
            'eventLabel': articleSlug,
        });
        e.preventDefault();
    });

    unmute.addEventListener("click", (e) => {
        sound.mute(false);
        unmute.style.display = "none";
        mute.style.display = "block";


        dataLayer.push({
            'event': 'GAEvent',
            'eventAction': 'unmute',
            'eventCategory': 'article_audio',
            'eventLabel': articleSlug,
        });
        e.preventDefault();
    });

    play.addEventListener("click", (e) => {
        sound.play();
        play.style.display = "none";
        pause.style.display = "block";

        progressTimer = window.setInterval(step, 100);

        dataLayer.push({
            'event': 'GAEvent',
            'eventAction': 'play',
            'eventCategory': 'article_audio',
            'eventLabel': articleSlug,
        });
        console.log("playing");
        e.preventDefault();

    });
    pause.addEventListener("click", (e) => {
        sound.pause();
        play.style.display = "block";
        pause.style.display = "none";
        clearInterval(progressTimer);

        dataLayer.push({
            'event': 'GAEvent',
            'eventAction': 'pause',
            'eventCategory': 'article_audio',
            'eventLabel': articleSlug,
        });
        e.preventDefault();
    });

    progress.addEventListener("click", (e) => {
        var xPos = e.clientX;
        var width = progress.clientWidth;
        var offset = progress.getClientRects()[0];

        var pct = (xPos - offset.left) / width;
        sound.seek(sound.duration() * pct);

        if (!sound.playing()) {
            document.querySelector(".play").click();
        }
        step();
    });




   
}

function formatTime(secs) {
    var minutes = Math.floor(secs / 60) || 0;
    var seconds = (secs - minutes * 60) || 0;

    return minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
};


if (document.readyState !== 'loading') {
    loadInteractivePDF();
    loadAuthorNote();
} else {
    document.addEventListener('DOMContentLoaded', function () {
        loadInteractivePDF();
        loadAuthorNote();
    });
}